export const planes = {
    AUTOSEGURO_LANDING_PAGE: 360,
}

export const tarificacionDefault = {
    itipopol: 'I',
    VigenciaPol: 'A',
    ncuotas: 1,
    marc: 0,
    mode: -1,
    anio: 0,
    tipo: 0,
    cate: 0,
    usoo: 1,
    nasiento: 0,
    valn: 0,
    suma: 0,
    valnreal: 0,
    GPS: 0,
    dedu: 0,
    rsat: 1,
    auNuevo: 0,
    showDialogFail: false
};

export const polizaDefault = {
    id: 0,
    file: {
        0: null,
        1: null,
        2: null
    },
    auFiles: {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
    },
    planId: planes.AUTOSEGURO_LANDING_PAGE,
    moneda: 'U$',
    frecuenciaPagos: '1',
    polCobs: [],
    esvhLocal:1
}

export const catalogosDefault = {
    rastreoSatelital: [],
    deducibles: [],
    marcas: [],
    modelos: [],
    anios: [],
    usos: [],
    coberturas: []
}

export const cotizadorDefault = {
    poliza: { ...polizaDefault },
    asegurado: {},
    tarificacion: { ...tarificacionDefault },
    catalogos: { ...catalogosDefault },
    setTarificacion: (obj) => { },
    setPoliza: (obj) => { },
    setCatalogos: (obj) => { },
    polizaChangeHandler: (event) => { },
    tarificacionChangeHandler: (event) => { },
    init: false
}

export const coberturasRequeridas = [];
export const coberturasOpcionales = [];

export const coberturaEquipoEspecial = 54;





export const buildTarificacionData = (planId, t) => {


    let data = {
        itipopol: 'I',
        VigenciaPol: 'A',
        ...t,
        cate: t.auCategoria,
        nasiento: t.auNumPasajeros,
        suma: t.valn,
        tipo: t.auTipo,
        //Codigos de descuento
        codigo2: 0,
        codigo5: 0,
        codigo8: 0,
        coverageIds: "[48,49,50,51,52,53,54,55,56,57,58,59,60,253]",
        CobSA54:0,
    }


   
    return data;
}

export const bulidDataToSave = (poliza, t, catalogos) => {

    let getfrecuencia = (n) => {
        switch (n) {
            case 12: return 'M'
            case 4: return 'T'
            case 2: return 'S'
            case 1: return 'A'
            default: return 'A'
        }
    }

    const isNullOrEmpty = (s) => s == null || s == '';

    poliza.polCobs.forEach(x => {
        x.mPrimaBruta = parseFloat(x.prima).toFixed(2);
    });

    return {
        ...poliza,
        sa: t.suma,
        plan: poliza.planId,
        beneficiarios: [],
        respuesta: [],
        itipopol: 'I',
        cuotas: poliza.ncuotas,
        frecuencia: getfrecuencia(poliza.ncuotas),
        formaPagos: {},
        asegurado: {
            tipoId: (poliza?.asegurado?.tipoId) ?? 3,
            numId: isNullOrEmpty(poliza?.asegurado?.numId) ? '000-010100-0000J' : poliza?.asegurado.numId,
            nombre: isNullOrEmpty(poliza?.asegurado?.nombre) ? 'prueba' : poliza?.asegurado.nombre,
            apellido: isNullOrEmpty(poliza?.asegurado?.apellido) ? 'prueba' : poliza?.asegurado.apellido,
            estadoCivil: 1,
            fechaNacimiento: '2021-12-27',
            profesion: 0,
            ocupacion: 0,
            sexo: 'M',
            actividad: 0,
            origenFondos: 0,
            OrigenFondosDetalle: '',
            Direccion: '',
            Departamento: 0,
            Municipio: 0,
            TelefonoCasa: '',
            TelefonoCelular: poliza?.asegurado?.TelefonoCelular,
            Email: poliza?.asegurado?.email,
            CasaPropia: null,
            TieneHijos: null,
            VehiculoPropio: null,
            NombreEmp: '',
            TelefonoEmp: '',
            ...poliza.asegurado
        },
        au: {
            tipo: 'AU',
            ramo: 1,
            sa: t.suma,
            auMarca: getCatalogText(catalogos, 'marcas', t.marc),
            auModelo: getCatalogText(catalogos, 'modelos', t.mode),
            auAnio: t.anio,
            auTipo: t.auTipo,
            auCategoria: t.auCategoria,
            auValorNuevo: t.valn,
            auNumPasajeros: t.auNumPasajeros,
            auUso: t.usoo,
            cia: 2,
            codigoMarca: t.marc,
            codigoModelo: t.mode,
            auGPS: t.GPS,
            auNuevo: t.auNuevo,
            ideducible: t.dedu,
            irastreoSatelital: t.rsat
        }
    };
}

const getCatalogText = (catalogs, name, value) => {
    if (catalogs[name] != null) {
        let c = catalogs[name].find(x => x.value == value);
        if (c != null)
            return c.text;
    }
    return '';
}

export const coverageDefault = {
    cobId: 0,
    name: '',
    sa: '',
    prima: '',
    sumInsureds: [],
    checked: false,
    selectedSA: null
}

export const isOldVh = (anio) => {
    const d = new Date();
    let year = d.getFullYear();

    return anio != null && (year - Number.parseInt(anio)) >= 15
}